import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import AppMuiThemeProvider from "./theme/AppMuiThemeProvider";

import AppRoutes from "./routes/AppRoutes";

import "./styles/main.css";

function hideAppSplash() {
  const splash = document.getElementById("app-splash");
  if (!splash || splash.classList.contains("is-hidden")) return;

  splash.classList.add("is-hidden");
  window.setTimeout(() => {
    splash.remove();
  }, 400);
}

function App() {
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(hideAppSplash);
    });
    return () => window.cancelAnimationFrame(frame);
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppMuiThemeProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </AppMuiThemeProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
